import { ProjectRow, SelectData } from "../../../../../models";

interface RowSelectionOptions {
  isLoading: boolean;
  getStandardOptions: (projectTypeUuid: string | null) => SelectData;
  getProjectTypeOptions: (standardUuid: string | null) => SelectData;
}

const isOffered = (options: SelectData, uuid: string | null): boolean =>
  !uuid || options.some((option) => String(option.key) === uuid);

/**
 * Standard and project type each narrow the other's list, so the pair the user ends up with has to
 * stay a pair the api accepts: a select whose value is missing from its own list renders blank
 * while the old uuid sits in state, and the api is only asked once the step is left.
 *
 * Changing one clears the other when the two no longer go together, which is also what stops the
 * form deadlocking - neither list can be narrowed down to nothing the user is allowed to pick.
 */
export const reconcileRowSelections = (
  previous: ProjectRow,
  next: ProjectRow,
  options: RowSelectionOptions
): ProjectRow => {
  // Every list is empty until the reference data lands, which would read as "nothing is compatible".
  if (options.isLoading) return next;

  if (next.projectTypeUuid !== previous.projectTypeUuid) {
    return isOffered(options.getStandardOptions(next.projectTypeUuid), next.standardUuid)
      ? next
      : { ...next, standardUuid: null };
  }

  if (next.standardUuid !== previous.standardUuid) {
    return isOffered(options.getProjectTypeOptions(next.standardUuid), next.projectTypeUuid)
      ? next
      : { ...next, projectTypeUuid: null };
  }

  return next;
};
